import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaContratosCovid from '../../components/contratos/listar/covid';


function CovidScreen () {
    return (
        <Fragment>
            <Head titulo="Contratos firmados durante a pandemia de COVID-19 no Município de Macuco"/>
            <Header />
            <Container>
                <ListaContratosCovid />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CovidScreen;